<template>
  <div class="layoutSelectBox">
    <div>
      <h6 v-if="type==='UNIT_PRODUCT'">{{ $t('selectBoxForQRcodeLayout') }}</h6>
      <h6 v-else>{{ $t('selectUsedBoxForQRcodeLayout') }}</h6>
    </div>
    <div class="grid">
      <div
        v-for="(box, index) in boxes"
        :key="index"
        :class="['box', { selected: box.selected }]"
        @click="toggleSelection(box)"
      ></div>
    </div>
    <br />
    <button class="save-btn" name="submit" type="submit" @click="exportQRCodePDF">
      {{ $t('generatePDF') }}
    </button>
  </div>
</template>

<script>
import UnitService from '@/services/UnitService.js'

export default {
  data() {
    return {
      boxes: [
        { label: 1, selected: false },
        { label: 2, selected: false },
        { label: 3, selected: false },
        { label: 4, selected: false },
        { label: 5, selected: false },
        { label: 6, selected: false },
        { label: 7, selected: false },
        { label: 8, selected: false },
        { label: 9, selected: false },
        { label: 10, selected: false },
        { label: 11, selected: false },
        { label: 12, selected: false },
        { label: 13, selected: false },
        { label: 14, selected: false },
        { label: 15, selected: false },
        { label: 16, selected: false },
        { label: 17, selected: false },
        { label: 18, selected: false },
        { label: 19, selected: false },
        { label: 20, selected: false },
        { label: 21, selected: false },
        { label: 22, selected: false },
        { label: 23, selected: false },
        { label: 24, selected: false },
        { label: 25, selected: false },
        { label: 26, selected: false },
        { label: 27, selected: false },
        { label: 28, selected: false },
        { label: 29, selected: false },
        { label: 30, selected: false },
        { label: 31, selected: false },
        { label: 32, selected: false },
        { label: 33, selected: false },
        { label: 34, selected: false },
        { label: 35, selected: false }
      ],
      selectedBoxes: [],
      lastSelectedBox: null
    }
  },
  methods: {
    toggleSelection(box) {
      if (this.type === 'UNIT_PRODUCT') {
        if (this.lastSelectedBox) {
          this.boxes[this.lastSelectedBox - 1].selected = false
        }
        this.lastSelectedBox = box.label
        box.selected = !box.selected
        this.selectedBoxes[0] = box.label
      } else {
        box.selected = !box.selected
        if (box.selected) {
          this.selectedBoxes.push(box.label)
        } else {
          const index = this.selectedBoxes.indexOf(box.label)
          if (index !== -1) {
            this.selectedBoxes.splice(index, 1)
          }
        }
      }
    },
    exportQRCodePDF() {
      if (this.type === 'CLIENT' || this.type === 'UNIT') {

        UnitService.downloadQRCodesPDF({
          unit_id: (this.unit) ? this.unit.id : undefined,
          used_boxes: this.selectedBoxes
        }).then(response => {
          const user = JSON.parse(localStorage.getItem('user'))
          const clientName = user
            ? `${user.firstName} ${user.lastName[0].toUpperCase()}.`
            : 'Client'

          let fileName
          if (this.type === 'CLIENT') {
            fileName = `Expar-QR-codes_${clientName}.pdf`
          } else if (this.type === 'UNIT') {
            fileName = `Expar-QR-codes_${clientName}_${this.unit.name}.pdf`
          }

          this.downloadPDF(response, fileName)
        })
      } else if (this.type === 'UNIT_PRODUCT') {

        UnitService.downloadSingleQRCodePDF({
          unit_id: this.unitId,
          product_id: this.productId,
          free_box: this.selectedBoxes
        }).then(response => {
          const fileName = `${this.unitId}-${this.productId}-QRcode.pdf`
          this.downloadPDF(response, fileName)
        })
      }
    },
    downloadPDF(response, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)

      fileLink.click()
      this.$emit('close-modal', null)
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    unit: {
      type: Object,
      required: false
    },
    unitId: {
      type: Number,
      required: false
    },
    productId: {
      type: Number,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.layoutSelectBox {
  width: 65%;
  margin: auto;
}

.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(7, 1fr);
  grid-gap: 10px;
  border: solid 1px var(--grey);
  padding: 5px;
}

.box {
  cursor: pointer;
  padding: 10px;
  width: auto;
  height: 70px;
  background-color: var(--bg-ultraLight);
}

.selected {
  background-color: var(--primarySuperLight);
}

.save-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.4em;
  margin: auto !important;
  letter-spacing: 0px;
  border: none;
  border-radius: 3.5px;
  height: 40px;
  text-align: center;
  width: 200px;
}
@media only screen and (max-width: 480px) {
  h5 {
    font-size: 0.8rem;
  }
  .box {
    height: 50px;
    padding: 8px;
  }
  .layoutSelectBox {
    width: 100%;
  }
}
</style>
